module.exports = __webpack_public_path__ + "static/img/step-071.902c3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-071.png
// module id = B/U5
// module chunks = 1